/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Scope_Point_2Inputs */

const en_svc_integration_scope_point_2 = /** @type {(inputs: Svc_Integration_Scope_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI data extraction from email and attachments into your systems`)
};

const lv_svc_integration_scope_point_2 = /** @type {(inputs: Svc_Integration_Scope_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI datu ieguve no e-pastiem un pielikumiem Jūsu sistēmās`)
};

/**
* | output |
* | --- |
* | "AI data extraction from email and attachments into your systems" |
*
* @param {Svc_Integration_Scope_Point_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_scope_point_2 = /** @type {((inputs?: Svc_Integration_Scope_Point_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Scope_Point_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_scope_point_2(inputs)
	return en_svc_integration_scope_point_2(inputs)
});